import { Injectable } from '@angular/core';
import { minify } from 'uglifyjs-browser';
import * as _ from 'lodash';
import pretty from 'pretty';

import { DictionaryService } from './dictionary.service';
import { UserService } from './user.service';

export enum SupplyType {
  Player = 0,
  Vast = 1,
  CedatoX = 2,
}

export enum PlayerTypes {
  Basic = 0,
  VCU = 1, // VCU types start
  InFeed = 1,
  // To be conntinued
}

export enum SupplyDeliveryMethod {
  Regular = 0,
  HB = 1,
}
export enum VastSubTypes {
  Vpaid = 0,
  Vast2Vast = 1,
}

type MacroDef = Record<string, string | boolean>;

@Injectable()
export class SupplyService {
  public supplyTypeSettings = [
    { id: SupplyType.Player, sections: [true, true, true, true, false, true, true, true, true, true], active: true }, // HTML Player
    { id: SupplyType.Vast, sections: [true, true, true, false, false, true, true, true, true, true], active: true }, // VAST
    {
      id: SupplyType.CedatoX,
      sections: [true, true, true, false, true, true, true, false, false, true],
      active: true,
      hideFromPublishersNetwork: true,
    }, // CedatoX
    // ??? VastCTV
  ];
  public supplyTypes: Array<any>;
  public supplyMethods = [
    { id: SupplyDeliveryMethod.Regular, name: 'REGULAR' },
    { id: SupplyDeliveryMethod.HB, name: 'HB_' },
  ];

  public sideMenuSections: Array<any>;
  public subTypes: Array<any>;
  public vastSubTypes = [
    { id: VastSubTypes.Vpaid, view: this.dictionaryService.get('SUPPLY_SUB_TYPE_VPAID') },
    { id: VastSubTypes.Vast2Vast, view: this.dictionaryService.get('SUPPLY_SUB_TYPE_VAST') },
  ];

  public tagTypes: Array<any>;
  public sizeTypes: Array<any>;
  public targetingOptions: Array<any>;
  public playerSizes: Array<any>;
  public defaultPlayerSize: any;
  public eventsList: Array<any>;
  public supplyPartners: Array<any>;
  public cappingLimits: any;
  public partnersMacros: any;
  public supplyModel: any;
  public listsLimit: number;
  public ipListsLimit: number;
  public extraParamsDefaultValue: any;
  public contentUnitTagDefaults: Array<any>;
  public hbCostType: number;

  constructor(public dictionaryService: DictionaryService, public userService: UserService) {
    this.sideMenuSections = [
      { name: 'SETTINGS', value: 'supplySettings', toggleStatus: true },
      {
        name: 'ASSIGNED_CAMPAIGNS',
        value: 'demandAssignedCampaigns',
        toggleStatus: true,
        featureFlag: 'manage_campaigns',
        editModeOnly: true,
      },
      { name: 'ASSIGNED_DEMAND', value: 'supplyAssignedDemands', toggleStatus: true },
      { name: 'CONTENT', value: 'supplyContent', toggleStatus: true },
      { name: 'TARGETING', value: 'supplyTargeting', toggleStatus: true },
      { name: 'RESTRICTIONS', value: 'supplyRestrictions', toggleStatus: true },
      { name: 'CALLBACKS', value: 'supplyCallbacks', toggleStatus: true },
      { name: 'TAG', value: 'supplyTag', toggleStatus: true },
      {
        name: 'EXTRA_PARAMS',
        value: 'extraParams',
        toggleStatus: true,
        isAdminOnly: true,
        onIf: false,
        iconNameIfOn: 'file',
        iconTooltip: 'Extra Params were added',
      },
      { name: 'EXPERIMENTAL_FEATURES', value: 'experimentalFeatures', toggleStatus: true, isAdminOnly: true },
    ];
    this.supplyTypes = [];
    this.subTypes = [];
    this.cappingLimits = {};
    this.tagTypes = [
      {
        id: PlayerTypes.Basic,
        name: 'BASIC_PLAYER',
        tooltip: 'BASIC_PLAYER_TOOLTIP',
        DFP: false,
      },
      {
        id: PlayerTypes.InFeed,
        name: 'IN_FEED',
        tooltip: 'IN_FEED_TOOLTIP',
        DFP: false,
        sizeTypes: [
          { label: this.dictionaryService.get('MATCH_TO_DIV'), value: 0 },
          { label: this.dictionaryService.get('WIDTH_X_HEIGHT'), value: 1 },
          { label: this.dictionaryService.get('RATIO'), value: 2 },
        ],
        defaults: {
          width: 300,
          height: 250,
          soundOnHover: false,
        },
      },
      {
        id: 9,
        name: 'IN_FEED_FOR_DFP',
        tooltip: 'IN_FEED_FOR_DFP_TOOLTIP',
        DFP: true,
        sizeTypes: [
          { label: this.dictionaryService.get('MATCH_TO_DIV'), value: 0 },
          { label: this.dictionaryService.get('RATIO'), value: 2 },
        ],
        defaults: {
          width: 300,
          height: 250,
          soundOnHover: false,
          ratio: 0.6,
        },
      },
      {
        id: 2,
        name: 'IN_CONTENT',
        tooltip: 'IN_CONTENT_TOOLTIP',
        DFP: false,
        sizeTypes: [
          { label: this.dictionaryService.get('MATCH_TO_DIV'), value: 0 },
          { label: this.dictionaryService.get('WIDTH_X_HEIGHT'), value: 1 },
          { label: this.dictionaryService.get('RATIO'), value: 2 },
        ],
        defaults: {
          width: 300,
          height: 250,
          soundOnHover: false,
          closeOnAdEnd: true,
          closeOnContentEnd: false,
        },
      },
      {
        id: 5,
        name: 'IN_CONTENT_FOR_DFP',
        tooltip: 'IN_CONTENT_FOR_DFP_TOOLTIP',
        DFP: true,
        sizeTypes: [
          { label: this.dictionaryService.get('MATCH_TO_DIV'), value: 0 },
          { label: this.dictionaryService.get('RATIO'), value: 2 },
        ],
        defaults: {
          soundOnHover: false,
          closeOnAdEnd: true,
          closeOnContentEnd: false,
        },
      },
      {
        id: 4,
        name: 'PERSISTENT',
        tooltip: 'PERSISTENT_TOOLTIP',
        DFP: false,
        sizeTypes: [
          { label: this.dictionaryService.get('MATCH_TO_DIV'), value: 0 },
          { label: this.dictionaryService.get('WIDTH_X_HEIGHT'), value: 1 },
          { label: this.dictionaryService.get('RATIO'), value: 2 },
        ],
        defaults: {
          width: 480,
          height: 320,
          soundOnHover: false,
        },
      },
      {
        id: 6,
        name: 'PERSISTENT_FOR_DFP',
        tooltip: 'PERSISTENT_FOR_DFP_TOOLTIP',
        DFP: true,
        sizeTypes: [
          { label: this.dictionaryService.get('MATCH_TO_DIV'), value: 0 },
          { label: this.dictionaryService.get('RATIO'), value: 2 },
        ],
        defaults: {
          soundOnHover: false,
        },
      },
      {
        id: 7,
        name: 'CORNER',
        tooltip: 'CORNER_TOOLTIP',
        DFP: false,
        sizeTypes: [
          { label: this.dictionaryService.get('RATIO'), value: 0 },
          { label: this.dictionaryService.get('WIDTH_X_HEIGHT'), value: 1 },
        ],
        defaults: {
          width: 300,
          soundOnHover: false,
        },
      },
      {
        id: 8,
        name: 'CORNER_FOR_DFP',
        tooltip: 'CORNER_FOR_DFP_TOOLTIP',
        DFP: true,
        sizeTypes: [
          { label: this.dictionaryService.get('RATIO'), value: 0 },
          { label: this.dictionaryService.get('WIDTH_X_HEIGHT'), value: 1 },
        ],
        defaults: {
          soundOnHover: false,
        },
      },
      {
        id: 3,
        name: 'PARALLAX',
        tooltip: 'PARALLAX_TOOLTIP',
        DFP: false,
        sizeTypes: [
          { label: this.dictionaryService.get('MATCH_TO_DIV'), value: 0 },
          { label: this.dictionaryService.get('WIDTH_X_HEIGHT'), value: 1 },
          { label: this.dictionaryService.get('RATIO'), value: 2 },
        ],
        defaults: {
          width: 480,
          height: 320,
          soundOnHover: false,
        },
      },
    ];
    this.sizeTypes = [
      { label: this.dictionaryService.get('MATCH_TO_DIV'), value: 0 },
      { label: this.dictionaryService.get('WIDTH_X_HEIGHT'), value: 1 },
      { label: this.dictionaryService.get('RATIO'), value: 2 },
    ];
    this.targetingOptions = [
      { id: 0, name: 'ALL' },
      { id: 1, name: 'INCLUDE' },
      { id: 2, name: 'EXCLUDE' },
    ];
    this.playerSizes = [
      { name: '640x360', val: '640x360', width: 640, height: 360 },
      { name: '480x360', val: '480x360', width: 480, height: 360 },
      { name: '300x250', val: '300x250', width: 300, height: 250 },
      { name: 'Custom', val: 'Custom' },
    ];
    this.defaultPlayerSize = this.playerSizes[0];

    this.eventsList = [
      { name: this.dictionaryService.get('PLAYER_READY'), eventId: 1, typeId: 0 },
      { name: this.dictionaryService.get('AD_START'), eventId: 2, typeId: 0 },
      { name: this.dictionaryService.get('AD_COMPLETE'), eventId: 3, typeId: 0 },
      { name: this.dictionaryService.get('AD_CLICK'), eventId: 4, typeId: 0 },
      { name: this.dictionaryService.get('IVT_DETECTION'), eventId: 2, typeId: 1 },
    ];
    this.supplyPartners = [
      { name: 'Cedato', val: '0' },
      { name: 'Google Ad Manager', val: '14' },
      { name: 'AVAZU', val: '1' },
      { name: 'Beeswax', val: '2' },
      { name: 'DFP', val: '3' },
      { name: 'JW Player', val: '4' },
      { name: 'Taggify', val: '5' },
      { name: 'Nuviad', val: '6' },
      { name: 'Pocketmath', val: '7' },
      { name: 'Sitescout', val: '8' },
      { name: 'Platform161', val: '9' },
      { name: 'Smadex', val: '10' },
      { name: 'Appreciate', val: '11' },
      { name: 'MediaSmart', val: '12' },
      { name: 'PEAK 226', val: '13' },
    ];
    this.partnersMacros = {
      0: {
        common: {
          cb: '[CB]',
          sid: 'EXTRACTED_DOMAIN',
          d: '[URL]',
          videocontentid: '[VIDEO_ID]',
          videocontentlength: '[VIDEO_LENGTH]',
          videocontenttitle: '[VIDEO_TITLE]',
          videocontenturl: '[VIDEO_FILE_URL]',
          gdpr: '[GDPR]',
          gdpr_consent: '[GDPR_CONSENT]',
          us_privacy: '[US_PRIVACY]',
          schain: '[SCHAIN]',
          overrideIP: '[IP]',
          ua: '[UA]',
          w: '[WIDTH]',
          h: '[HEIGHT]',
        },
        app: {
          sid: '[APP_BUNDLE]',
          appn: '[APP_NAME]',
          appv: '[APP_VER]',
          appb: '[APP_BUNDLE]',
          appsu: '[APP_STORE_URL]',
          ifa: '[IFA]',
          appsi: '[APP_STORE_ID]',
          appc: '[APP_CATEGORY]',
          country: '[COUNTRY_ID]',
          loc: '[LOCATION]',
          loclong: '[LOCATION_LONG]',
          loclat: '[LOCATION_LAT]',
          deviceid: '[DEVICEID]',
          d: '[APP_BUNDLE]',
          dnt: '[DNT]',
        },
        all: {},
        tagTypeRestrictions: {
          0: true,
          1: true,
          2: false,
          3: true,
        },
        enabled: true,
        showCommon: true,
        showMobile: true,
        showMobileGeneral: true,
        showCommonGeneral: true,
      },
      1: {
        common: {
          cb: '{timestamp}',
          sid: 'EXTRACTED_DOMAIN',
          d: '{site_url}',
        },
        app: {
          sid: '{bundle_id}_{exchange}',
          appn: ' {source_id}',
          appv: false,
          appb: ' {bundle_id}',
          appsu: '{appstore_url}',
          ifa: '{ifa}',
          appsi: false,
          appc: '{category}',
          country: '{country}',
          loc: false,
          loclong: false,
          loclat: false,
          deviceid: '{device_model}',
          d: '{bundle_id}',
        },
        all: {},
        tagTypeRestrictions: {
          0: true,
          1: false,
          2: false,
        },
        enabled: true,
        showCommon: true,
        showMobile: true,
        showMobileGeneral: true,
        showCommonGeneral: true,
      },
      2: {
        common: {
          cb: '{{CACHEBUSTER}}',
          sid: 'EXTRACTED_DOMAIN',
          d: '{{DOMAIN}}',
        },
        app: {
          sid: '{{APP_BUNDLE}}',
          appn: '{{APP_NAME}}',
          appv: false,
          appb: '{{APP_BUNDLE}}',
          appsu: false,
          ifa: '{{USER_ID}}',
          appsi: false,
          appc: false,
          country: false,
          loc: false,
          loclong: '{{LONG}}',
          loclat: '{{LAT}}',
          deviceid: '{{PLATFORM_OS}}',
          d: '{{APP_BUNDLE}}',
        },
        all: {},
        tagTypeRestrictions: {
          0: true,
          1: false,
          2: false,
        },
        enabled: true,
        showCommon: true,
        showMobile: true,
        showMobileGeneral: true,
        showCommonGeneral: true,
      },
      '3': {
        common: {
          cb: '%%CACHEBUSTER%%',
          sid: 'EXTRACTED_DOMAIN',
          d: '%%REFERRER_URL%%',
          overrideIP: '[IP]',
        },
        app: {
          appn: false,
          appv: false,
          appb: false,
          appsu: false,
          ifa: '%%ADVERTISING_IDENTIFIER_PLAIN%%',
          appsi: false,
          appc: false,
          country: false,
          loc: false,
          loclong: false,
          loclat: false,
          deviceid: false,
        },
        all: {},
        tagTypeRestrictions: {
          0: true,
          1: false,
          2: false,
        },
        enabled: true,
        showCommon: true,
        showMobile: false,
        showMobileGeneral: true,
        showCommonGeneral: true,
      },
      '4': {
        common: {
          cb: '__random-number__',
          sid: '__referrer__',
          d: '__page-url__',
        },
        app: {
          appn: false,
          appv: false,
          appb: false,
          appsu: false,
          appidfa: false,
          appaid: false,
          appsi: false,
          appc: false,
          country: false,
          loc: false,
          loclong: false,
          loclat: false,
          deviceid: false,
        },
        all: {},
        tagTypeRestrictions: {
          0: false,
          1: true,
          2: false,
        },
        enabled: true,
        showCommon: true,
        showMobile: true,
        showMobileGeneral: true,
        showCommonGeneral: true,
      },
      '5': {
        common: {
          cb: '{cachebuster}',
          sid: '{pubid}_{ssp}',
          d: '{domain}',
        },
        app: {
          sid: '{bundle}',
          appn: '{name}',
          appv: '{ver}',
          appb: '{bundle}',
          appsu: '{storeurl}',
          ifa: '{ifa}',
          appsi: false,
          appc: false,
          country: '{country}',
          loc: false,
          loclong: '{long}',
          loclat: '{lat}',
          deviceid: '{device}',
          d: '{bundle}',
        },
        all: {},
        tagTypeRestrictions: {
          0: true,
          1: false,
          2: false,
        },
        enabled: true,
        showCommon: true,
        showMobile: true,
        showMobileGeneral: true,
        showCommonGeneral: true,
      },
      '6': {
        common: {
          cb: '{{TIMESTAMP}}',
          sid: '{{SITE_DOMAIN}}_{{EXCHANGE_ENC}}',
          d: '{{SITE_DOMAIN}}',
        },
        app: {
          sid: '{{APP_BUNDLE}}',
          appn: '{{APP_NAME_ENC}}',
          appv: '{{APP_VERSION}}',
          appb: '{{APP_BUNDLE}}',
          appsu: '{{APP_STOREURL}}',
          ifa: '{{DEVICE_IFA}}',
          appsi: '{{APP_BUNDLE}}',
          appc: '{{APP_CATEGORY_ENC}}',
          country: '{{USER_COUNTRY}}',
          loc: false,
          loclong: '{{USER_GEO_LNG}}',
          loclat: '{{USER_GEO_LAT}}',
          deviceid: '{{DEVICE_IFA}}',
          d: '{{APP_BUNDLE}}',
        },
        all: {},
        tagTypeRestrictions: {
          0: true,
          1: false,
          2: false,
        },
        enabled: true,
        showCommon: true,
        showMobile: true,
        showMobileGeneral: true,
        showCommonGeneral: true,
      },
      '7': {
        common: {
          cb: '${imp_id_qp}',
          sid: 'EXTRACTED_DOMAIN',
          d: '${page_url_qp}',
        },
        app: {
          sid: '${bundle_id_qp}',
          appn: '${source_id_qp}',
          appv: false,
          appb: '${bundle_id_qp}',
          appsu: false,
          appidfa: '${ifa_qp}',
          appaid: false,
          appsi: false,
          appc: false,
          country: false,
          loc: false,
          loclong: '${lon_qp}',
          loclat: '${lat_qp}',
          deviceid: '${sha1_did_qp}',
          d: '${bundle_id_qp}',
        },
        all: {},
        tagTypeRestrictions: {
          0: true,
          1: false,
          2: false,
        },
        enabled: true,
        showCommon: true,
        showMobile: true,
        showMobileGeneral: true,
        showCommonGeneral: true,
      },
      '8': {
        common: {
          cb: '{ts}',
          sid: '{campaignId}^{networkId}^{siteId}',
          d: '{domain}',
        },
        app: {
          sid: '{networkId}_{siteId}',
          d: '{appId}',
          appn: '{appId}',
          appv: false,
          appb: '{appId}',
          appsu: false,
          ifa: '{ifa}',
          appsi: false,
          appc: false,
          country: false,
          loc: '{latitude},{longitude}',
          loclong: '{longitude}',
          loclat: '{latitude}',
          deviceid: '{device}',
        },
        all: {},
        tagTypeRestrictions: {
          0: true,
          1: true,
          2: true,
        },
        enabled: true,
        showCommon: true,
        showMobile: true,
        showMobileGeneral: true,
        showCommonGeneral: true,
      },
      '9': {
        common: {
          cb: '${Rnd}',
          sid: 'EXTRACTED_DOMAIN',
          d: '${DetectedDomain}',
        },
        app: {
          sid: '${AppBundle}',
          appn: '${AppName}',
          appv: false,
          appb: '${AppBundle}',
          appsu: '${AppURL}',
          appidfa: '${IDFA}',
          appaid: '${AID}',
          appsi: false,
          appc: false,
          country: '${Country}',
          d: '${AppBundle}',
          loc: false,
          loclong: false,
          loclat: false,
          deviceid: false,
        },
        all: {},
        tagTypeRestrictions: {
          0: true,
          1: false,
          2: false,
        },
        enabled: true,
        showCommon: true,
        showMobile: true,
        showMobileGeneral: true,
        showCommonGeneral: true,
      },
      '10': {
        common: {
          cb: '{$timestamp$}',
          sid: 'EXTRACTED_DOMAIN',
          d: '{$INVENTORY_DOMAIN$}',
        },
        app: {
          sid: '{$APP_BUNDLE$}',
          appn: '{$APP_NAME$}',
          appv: false,
          appb: '{$APP_BUNDLE$}',
          appsu: '{$APP_STORE_URL$}',
          appidfa: '{$IDFA_RAW$}',
          appaid: '{$GAID_RAW$}',
          appsi: false,
          appc: '{$APP_CATEGORIES$}',
          country: false,
          loc: false,
          loclong: '{$LON$}',
          loclat: '{$LAT$}',
          deviceid: false,
          d: '{$APP_BUNDLE$}',
        },
        all: {},
        tagTypeRestrictions: {
          0: true,
          1: false,
          2: false,
        },
        enabled: true,
        showCommon: true,
        showMobile: true,
        showMobileGeneral: true,
        showCommonGeneral: true,
      },
      '11': {
        common: {
          cb: '[CACHEBUSTER]',
          sid: '[APP_BUNDLE]',
          d: '[APP_BUNDLE]',
        },
        app: {
          sid: '[APP_BUNDLE]_[EXCHANGE_NAME]',
          appn: '[APP_NAME]',
          appv: '[APP_VER]',
          appb: '[APP_BUNDLE]',
          appsu: '[APP_STORE_URL]',
          appidfa: '[IFA_ANDROID]',
          appaid: '[IFA_ANDROID]',
          appsi: '[APP_STORE_ID]',
          appc: '[APP_CATEGORY]',
          country: '[COUNTRY_ISO]',
          loc: '[LOCATION]',
          loclong: '[LOCATION_LONG]',
          loclat: '[LOCATION_LAT]',
          deviceid: '[IFA_ANDROID]',
          d: '[APP_BUNDLE]',
          c1: '[REGION_BID_ID]',
        },
        all: {},
        tagTypeRestrictions: {
          0: true,
          1: false,
          2: false,
        },
        enabled: true,
        showCommon: true,
        showMobile: true,
        desktopRejectMessage:
          'Appreciate does not operate on Desktop and Mobile Web traffic. Please use a dedicated Mobile App Supply to be able to generate a Supply tag template for Appreciate.',
        showMobileGeneral: true,
        showCommonGeneral: true,
      },
      '12': {
        common: {
          cb: '%ts%',
          sid: '%domain%',
          d: '%page%',
        },
        app: {
          sid: '%bundle%',
          appn: '%app_name%',
          appv: false,
          appb: '%bundle%',
          appsu: '%domain%',
          appidfa: '%creative%',
          appaid: '%app_id%',
          appsi: false,
          appc: '%rtb_categories%',
          country: '%country%',
          loc: '%loc%',
          loclong: false,
          loclat: false,
          deviceid: '%udid%',
          d: '%bundle%',
        },
        all: {},
        tagTypeRestrictions: {
          0: true,
          1: false,
          2: false,
        },
        enabled: true,
        showCommon: true,
        showMobile: true,
        showMobileGeneral: true,
        showCommonGeneral: true,
      },
      '13': {
        common: {
          cb: '${CACHE_BUSTER}',
          sid: 'EXTRACTED_DOMAIN',
          d: '${DOMAIN}',
        },
        app: {
          sid: '${APP_BUNDLE_ID}',
          appn: '${APP_NAME}',
          appv: '[APP_VER]',
          appb: '${APP_BUNDLE_ID}',
          appsu: '${APP_STORE_URL}',
          appidfa: '${IOS_IFA}',
          appaid: '${GOOGLE_AID}',
          appsi: '[APP_STORE_ID]',
          appc: '[APP_CATEGORY]',
          country: '[COUNTRY_ID]',
          loc: '[LOCATION]',
          loclong: '${LONGITUDE}',
          loclat: '${LATITUDE}',
          deviceid: '[DEVICEID]',
          d: '${APP_BUNDLE_ID}',
          ho: '1',
        },
        ctv: {
          sid: 'EXTRACTED_DOMAIN',
          appn: '[APP_NAME]',
          appb: '[APP_BUNDLE]',
        },
        all: {},
        tagTypeRestrictions: {
          '0': true,
          '1': true,
          '2': false,
          '3': true,
        },
        enabled: true,
        showCommon: true,
        showMobile: true,
        showMobileGeneral: true,
        showCommonGeneral: true,
      },
      '14': {
        common: {
          cb: '%%CACHEBUSTER%%',
          sid: 'EXTRACTED_DOMAIN',
          d: '%%PATTERN:url%%',
          w: '%%WIDTH%%',
          h: '%%HEIGHT%%',
        },
        app: {
          sid: '{networkId}_{siteId}',
          d: '{appId}',
          appn: '{appId}',
          appv: false,
          appb: '{appId}',
          appsu: false,
          ifa: '{ifa}',
          appsi: false,
          appc: false,
          country: false,
          loc: '{latitude},{longitude}',
          loclong: '{longitude}',
          loclat: '{latitude}',
          deviceid: '{device}',
        },
        all: {},
        tagTypeRestrictions: {
          '1': true,
        },
        enabled: true,
        showCommon: true,
        showMobile: true,
        showMobileGeneral: true,
        showCommonGeneral: true,
      },
    };
    this.contentUnitTagDefaults = [];
    this.supplyModel = {
      name: '',
      type: 0,
      sub_type: 0,
      networkId: 0,
      active: true,
      limitAssign: false,
      is_desktop: false,
      is_mobile_web: false,
      is_mobile_app: false,
      is_ctv: false,
      partnerId: null,
      partnerName: null,
      tagType: 0,
      sizeType: 0,
      floorCPMPrice: null,
      costType: 7,
      costValue: 0,
      rotation: true,
      rotationNumber: 0,
      html5Only: false,
      controlBar: false,
      contentImage: '',
      contentVideo: '',
      asSoonAsAvailable: true,
      preRoll: false,
      preRollTime: 4,
      midRoll: false,
      midRollAllowedAdDelay: 4,
      midRollFirstAdTime: 6,
      midRollInterval: 60,
      postRoll: false,
      loopContent: false,
      contentControlBar: false,
      clickURL: '',
      shuffleVideoPlaylist: false,
      videoDescription: '',
      videoKeywords: '',
      videoTitle: '',
      autoPlay: true,
      passback: false,
      passbackCode: '',
      passbackTimeout: 15,
      vastRequestLimit: 3,
      custom_vastRequestLimit: 1,
      custom_mvr: false,
      maxTotalVastRequests: 0,
      callbacks: [],
      supplyPartner: this.supplyPartners[0],
      domainListType: 0,
      domainLists: [],
      urlListType: 0,
      urlLists: [],
      ipListType: 0,
      ipLists: [],
      playerSize: this.defaultPlayerSize,
      width: this.defaultPlayerSize.width,
      height: this.defaultPlayerSize.height,
      ratio: 0.6,
      cornerWidth: 300,
      domain: 'EXTRACTED_DOMAIN',
      subId: 'EXTRACTED_DOMAIN',
      secure: true,
      mobileApp: false,
      closeButton: true,
      closeOnAdEnd: true,
      closeOnContentEnd: false,
      soundOnHover: true,
      playOnVisibility: 50,
      pauseOnVisibility: 25,
      pauseOnHiddenTab: true,
      boxHeight: 1000,
      boxColor: '555555',
      persistentWidth: 300,
      persistentHeight: 250,
      persistentLocationYPx: 50,
      persistentLocationYFrom: 'bottom',
      persistentLocationXPx: 30,
      persistentLocationXFrom: 'right',
      persistentPadding: 5,
      cxTrafficSourceAllowedHTML: true,
      cxTrafficSourceAllowedVAST: true,
      extra_params_enabled: false,
      extra_params: '{}',
      player_capping: [
        {
          active: false,
          cappingType: 1,
          cappingValue: null,
          paceOption: 1,
        },
        {
          active: false,
          cappingType: 2,
          cappingValue: null,
          paceOption: 1,
        },
      ],
      tagSchemaSelected: {
        tagSizeSelected: {
          name: '300x250',
          val: '300x250',
          width: 300,
          height: 250,
        },
        vpaidTypeSelected: {
          name: 'VPAID',
          val: '',
        },
        tagSize: {
          width: 300,
          height: 250,
        },
        tagSecure: true,
        tagMobileApp: false,
        tagSubId: 'EXTRACTED_DOMAIN',
        tag_domain_selected: {
          domainId: 0,
          domain: '',
        },
      },
      targeting: {
        dma: { type: 0, list: [] },
        location: { type: 0, list: [] },
        browsers: { type: 0, list: [] },
        os: { type: 0, list: [] },
        targetingSizes: { type: 0, list: [] },
        envs: { type: 0, list: [] },
        vast_domains: { type: 0, list: [] },
        targeting_id: 0,
        state: { type: 0, list: [] },
      },
      contentUnitTag: {
        tag_type_id: 2,
        ad_manager: 0,
        safe_frame: 0,
        config: {
          composerEnabled: false,
          vpaidEnabled: false,
          intentEnabled: false,
          dfpEnabled: false,
          dfpPlacement: false,
          dfpNestLevel: {
            iframeDepth: 1,
            documentDepth: 2,
          },
          unitType: 'zplayer',
          autodetectDomain: true,
          dynamicPresets: false,
          unitVersion: '',
          playerConfig: {
            player: {
              extraParams:
                '&c1=[CUSTOM1]&c2=[CUSTOM2]&c3=[CUSTOM3]&c4=[CUSTOM4]&c5=[CUSTOM5]&c6=[CUSTOM6]&c7=[CUSTOM7]&c8=[CUSTOM8]&c9=[CUSTOM9]&c10=[CUSTOM10]&c11=[CUSTOM11]&c12=[CUSTOM12]&c13=[CUSTOM13]&c14=[CUSTOM14]&c15=[CUSTOM15]&c16=[CUSTOM16]&c17=[CUSTOM17]&c18=[CUSTOM18]&c19=[CUSTOM19]&c20=[CUSTOM20]&schain=[SCHAIN]',
              subId: '[SUBID]',
              playerId: '[SUPPLY_ID]',
            },
            position: {
              container: 'cedato-unit',
              ratio: 0.5625,
            },
            listview: true,
            theme: {
              color: '#3350a2',
              colorLight: 'rgba(17, 175, 204, 0.5)',
            },
            brand: {
              imageUrl: 'https://www.cedato.com/wp-content/uploads/2017/09/logo.png',
              clickUrl: 'https://www.cedato.com/',
            },
            unit: 'InFeed',
            tooltips: 'en',
          },
          libraries: false,
          eventListener: '',
          eventListener_match: '**',
        },
      },
    };
    this.extraParamsDefaultValue = {
      url: '',
      json: '{}',
      extra_params_length: 0,
      extra_params_url_length: 0,
    };
    this.listsLimit = 30;
    this.ipListsLimit = 5;
    this.hbCostType = 7;
  }

  paramFactory(is_app: boolean, supplyPartner: number): (p: string) => string {
    const macros: { common: MacroDef; app: MacroDef } = this.partnersMacros[supplyPartner.toString()];
    return (param: string) => {
      let p: string | boolean = '';
      if (is_app) {
        p = macros.app[param];
      }
      if (p === false) {
        return '';
      }
      if (!p) {
        p = macros.common[param];
      }
      if (p === false) {
        return '';
      }
      if (p == null) {
        p = `[${param.toUpperCase()}]`;
      }
      return `&${param}=${p}`;
    };
  }

  AppParams = [
    'appb',
    'appc',
    'appn',
    'appsi',
    'appsu',
    'appv',
    'country',
    'deviceid',
    'ifa',
    'loc',
    'loclat',
    'loclong',
  ];
  PrivacyParams = ['gdpr', 'gdpr_consent', 'us_privacy'];

  generateBasic(playerID: string, supplyData: any, networkURI: string, previewPlayerId: (divid: string) => void) {
    let htmlTag = '';

    const protocol: string = supplyData.secure ? 'https' : 'http';

    const macros = this.partnersMacros[supplyData.supplyPartner.val.toString()];
    const Param = this.paramFactory(supplyData.is_ctv || supplyData.is_mobile_app, supplyData.supplyPartner.val);
    const Params = (p: string[]) => p.map((v) => Param(v)).join('');

    const cb = macros.common['cb'];

    if (supplyData.type === SupplyType.Player) {
      const divid = `video${playerID}${cb}`;
      let tagParams = '';
      if (this.userService.isPublisher() && supplyData.domainSelected) {
        tagParams += `&d=${supplyData.domainSelected}`;
      } else {
        tagParams += Param('d');
      }
      tagParams += Param('sid');
      if (supplyData.is_mobile_app || supplyData.is_ctv) {
        tagParams += Params(this.AppParams);
      }
      tagParams += Params(this.PrivacyParams);
      tagParams += Param('schain');

      htmlTag = `<div id="${divid}" style="width: ${supplyData.width}px; height: ${supplyData.height}px;">`;
      htmlTag += `<script src="${protocol}://p.${networkURI}/player/player.js?p=${supplyData.playerId}&cb=${cb}&w=${supplyData.width}&h=${supplyData.height}${tagParams}" type="text/javascript"></script>`;
      if (supplyData.passback && supplyData.passbackTimeout && supplyData.passbackCode) {
        htmlTag += `<script type="cedato/passback" data-timeout="` + supplyData.passbackTimeout + `">`;
        htmlTag += '<!-- _PASSBACK_ -->';
        htmlTag += `</script>`;
      }
      htmlTag += `</div>`;
      htmlTag = pretty(htmlTag);
      htmlTag = htmlTag.replace('<!-- _PASSBACK_ -->', supplyData.passbackCode.replace(/<\/script/g, '<\\/script'));
      previewPlayerId(divid);
    } else if (supplyData.type === SupplyType.Vast) {
      htmlTag = `${protocol}://${['v', 'v2v'][supplyData.sub_type]}.${networkURI}/${
        ['vpvast', 'vast'][supplyData.sub_type]
      }?p=${supplyData.playerId}&cb=${cb}`;

      htmlTag += Param('d');
      if (supplyData.is_mobile_app || supplyData.is_ctv) {
        htmlTag += Params(this.AppParams);
      }

      htmlTag += Params(['w', 'h']);
      htmlTag += Params(this.PrivacyParams);
      htmlTag += Param('schain');

      if (supplyData.sub_type === VastSubTypes.Vast2Vast) {
        htmlTag += Params(['dnt', 'overrideIP', 'ua']);
      }
    }
    return htmlTag;
  }

  generateVCU(supplyData: any, dfp: boolean, networkURI: string) {
    const protocol: string = supplyData.secure ? 'https' : 'http';

    const position: any = {};
    let htmlTag = '';
    let styleTag = '';

    let persistentTop: string;
    let persistentBottom: string;
    let persistentRight: string;
    let persistentLeft: string;

    if (supplyData.tagType === 4 || supplyData.tagType === 7) {
      if (supplyData.persistentLocationYFrom === 'bottom') {
        persistentBottom = '0';
        persistentTop = 'auto';
      } else {
        persistentBottom = 'auto';
        persistentTop = '0';
      }
      if (supplyData.persistentLocationXFrom === 'right') {
        persistentRight = '0';
        persistentLeft = 'auto';
      } else {
        persistentRight = 'auto';
        persistentLeft = '0';
      }
    } else if (supplyData.tagType === 6 || supplyData.tagType === 8) {
      if (supplyData.persistentLocationYFrom === 'bottom') {
        persistentBottom = supplyData.persistentLocationYPx.toString() + 'px';
        persistentTop = 'auto';
      } else {
        persistentBottom = 'auto';
        persistentTop = supplyData.persistentLocationYPx.toString() + 'px';
      }
      if (supplyData.persistentLocationXFrom === 'right') {
        persistentRight = supplyData.persistentLocationXPx.toString() + 'px';
        persistentLeft = 'auto';
      } else {
        persistentRight = 'auto';
        persistentLeft = supplyData.persistentLocationXPx.toString() + 'px';
      }
    }

    const Param = this.paramFactory(supplyData.is_ctv || supplyData.is_mobile_app, supplyData.supplyPartner.val);
    const Params = (p: string[]) => p.map((v) => Param(v)).join('');

    if (!dfp) {
      htmlTag += `<div id="ads"`;
      if (supplyData.sizeType === 1 && supplyData.tagType !== 7) {
        htmlTag += ` style="width: ` + supplyData.width + `px; height: ` + supplyData.height + `px"`;
      }
      htmlTag += '></div>';
    } else {
      htmlTag += `<script src="//c.${networkURI}/player/ad-units.2.1.js"></script>`;
    }
    htmlTag += `<script>`;
    if (!dfp) {
      htmlTag += `document.addEventListener('cedatoAdUnitReady', function() { `;
    }
    htmlTag += `CEDATO.`;
    switch (supplyData.tagType) {
      case 1:
      case 9:
        htmlTag += `AdPlayer`;
        break;
      case 2:
      case 5:
        htmlTag += `InContent`;
        break;
      case 3:
        htmlTag += `Parallax`;
        break;
      case 4:
      case 6:
        htmlTag += `Persistent`;
        break;
      case 7:
      case 8:
        htmlTag += `Corner`;
        break;
    }
    htmlTag += `({player: {`;
    htmlTag += `playerId: ` + supplyData.playerId + `,`;
    if (!dfp) {
      htmlTag += `protocol: '` + protocol + `:',`;
    }
    htmlTag += `domain: '` + supplyData.domain + `',`;
    htmlTag += `servingDomain: '${networkURI}',`;
    htmlTag += `extraParams: ` + `'${Params([...this.PrivacyParams, 'schain'])}'` + `,`;
    htmlTag += `},`;
    if (supplyData.tagType !== 7 && supplyData.tagType !== 8) {
      if (supplyData.sizeType !== 0) {
        if (!dfp) {
          position.container = 'ads';
        }
        if (supplyData.sizeType === 1) {
          position.width = supplyData.width;
          position.height = supplyData.height;
        } else if (supplyData.sizeType === 2) {
          position.ratio = supplyData.ratio;
        }
      }
    } else {
      if (supplyData.tagType !== 8) {
        position.container = 'ads';
      }
      if (supplyData.sizeType === 0) {
        if (supplyData.tagType !== 8) {
          position.width = supplyData.cornerWidth;
        }
        position.ratio = supplyData.ratio;
      } else if (supplyData.sizeType === 1) {
        if (supplyData.tagType !== 8) {
          position.width = supplyData.width;
          position.height = supplyData.height;
        }
      }
    }
    if (supplyData.tagType === 6) {
      position.injectCss =
        `.__cedato_persistent { width: ` +
        supplyData.persistentWidth +
        `px; height: ` +
        supplyData.persistentHeight +
        `px; bottom: ` +
        persistentBottom +
        `; left: ` +
        persistentLeft +
        `; top: ` +
        persistentTop +
        `; right: ` +
        persistentRight +
        `; }`;
    } else if (supplyData.tagType === 8) {
      position.injectCss = `.__cedato_corner  { width: `;
      if (supplyData.sizeType === 0) {
        position.injectCss += supplyData.cornerWidth;
      } else if (supplyData.sizeType === 1) {
        position.injectCss += supplyData.width;
      }
      position.injectCss += `px; `;
      if (supplyData.sizeType === 1) {
        position.injectCss += `height: ` + supplyData.height + `px; `;
      }
      position.injectCss +=
        `bottom: ` +
        persistentBottom +
        `; left: ` +
        persistentLeft +
        `; top: ` +
        persistentTop +
        `; right: ` +
        persistentRight +
        `; }`;
    }
    if (Object.keys(position).length > 0) {
      htmlTag +=
        `position: ` +
        JSON.stringify(position)
          .replace(/\"([^(\")"]+)\":/g, '$1:')
          .replace(/\"/g, "'") +
        `,`;
    } else {
      if (supplyData.tagType !== 5 && supplyData.tagType !== 9) {
        htmlTag += `position: 'ads',`;
      }
    }
    htmlTag += `control: {`;
    if (supplyData.tagType !== 3) {
      htmlTag += `closeButton: ` + supplyData.closeButton + `,`;
    }
    if (supplyData.tagType === 2 || supplyData.tagType === 5 || supplyData.tagType === 7 || supplyData.tagType === 8) {
      htmlTag += `closeOnAdEnd: ` + supplyData.closeOnAdEnd + `,`;
      htmlTag += `closeOnContentEnd: ` + supplyData.closeOnContentEnd + `,`;
    }
    htmlTag += `soundOnHover: ` + supplyData.soundOnHover + `,`;
    if (supplyData.tagType !== 7 && supplyData.tagType !== 8) {
      htmlTag += `playOnVisibility: ` + supplyData.playOnVisibility + `,`;
      if (supplyData.tagType !== 4 && supplyData.tagType !== 6) {
        htmlTag += `pauseOnVisibility: ` + supplyData.pauseOnVisibility + `,`;
      }
    }
    htmlTag += `pauseOnHiddenTab: ` + supplyData.pauseOnHiddenTab;
    htmlTag += `},`;
    htmlTag += `});`;
    if (!dfp) {
      htmlTag += `});`;
    }
    htmlTag += `</script>`;
    if (!dfp) {
      htmlTag += `<script async src="http`;
      if (supplyData.secure) {
        htmlTag += `s`;
      }
      htmlTag += `://c.${networkURI}/player/ad-units.2.1.js"></script>`;
    }
    if (supplyData.tagType === 3) {
      styleTag =
        `<style> #ads { box-sizing: border-box; height: ` +
        supplyData.boxHeight +
        `px; background: #` +
        supplyData.boxColor +
        `; } </style>`;
    } else if (supplyData.tagType === 4) {
      styleTag =
        `<style> #ads .__cedato_persistent { padding: ` +
        supplyData.persistentPadding +
        `px; margin:  ` +
        supplyData.persistentLocationYPx +
        `px  ` +
        supplyData.persistentLocationXPx +
        `px; width:  ` +
        supplyData.persistentWidth +
        `px; height:  ` +
        supplyData.persistentHeight +
        `px; bottom: ` +
        persistentBottom +
        `; left: ` +
        persistentLeft +
        `; top: ` +
        persistentTop +
        `; right: ` +
        persistentRight +
        `; } #ads .__cedato_in_transit { -webkit-transition: all .3s ease-out; -moz-transition: all .3s ease-out; transition: all .3s ease-out; } </style>`;
    } else if (supplyData.tagType === 7) {
      if (persistentTop !== 'auto') {
        persistentTop = supplyData.persistentLocationYPx + 'px';
      }
      if (persistentRight !== 'auto') {
        persistentRight = supplyData.persistentLocationXPx + 'px';
      }
      if (persistentBottom !== 'auto') {
        persistentBottom = supplyData.persistentLocationYPx + 'px';
      }
      if (persistentLeft !== 'auto') {
        persistentLeft = supplyData.persistentLocationXPx + 'px';
      }
      styleTag =
        `<style> #ads .__cedato_corner  { margin:  ` +
        supplyData.persistentPadding +
        `px; width: auto; height: auto; bottom: ` +
        persistentBottom +
        `; left: ` +
        persistentLeft +
        `; top: ` +
        persistentTop +
        `; right: ` +
        persistentRight +
        `; } </style>`;
    }
    htmlTag = (pretty(htmlTag) as string)
      .split('\n')
      .filter((l) => l)
      .join('\n');
    htmlTag = styleTag + '\n' + htmlTag;
    return htmlTag;
  }

  // building wrapper code
  // parameters @supplyId @domain
  getContentUnitWrapperTag(supplyId: number, tagData: any) {
    const { ad_manager, safe_frame, config } = tagData;
    const eventListener = (config && config.eventListener) || '';
    const eventhandler =
      eventListener &&
      `<script>
  ${eventListener} = ({name,data}) => {
  /* console.log(name, data); */
  };
</script>
`;

    const ad_manager_off = `<div id="cedato-unit"></div>
<script src="https://p.@domain/zplayer.js?p=@supplyId@extra" type="text/javascript"></script>`;

    const ad_manager_on_regular = `<script src="https://p.@domain/zplayer.js?p=@supplyId&cb=%%CACHEBUSTER%%&d=%%PATTERN:url%%@extra" type="text/javascript">
</script>`;

    const ad_manager_on_safeframe = `<div id="cedato-unit" style="padding:0 1%;"/>
<script src="https://p.@domain/zplayer.js?p=@supplyId&cb=%%CACHEBUSTER%%&d=%%PATTERN:url%%@extra" type="text/javascript"></script>`;

    const networkURI = _.get(tagData.config, 'playerConfig.player.servingDomain');

    return (
      eventhandler +
      (ad_manager ? (safe_frame ? ad_manager_on_safeframe : ad_manager_on_regular) : ad_manager_off)
        .replace('@supplyId', supplyId + '')
        .replace('@domain', networkURI || this.userService.getDefaultDomainName())
        .replace('@extra', '&schain=[SCHAIN]&c1=[CUSTOM1]')
    );
  }

  getContentUnitWrapperCode(config: any) {
    const global_defs = {};
    const { servingDomain } = _.get(
      config.playerConfig,
      'player',
      this.supplyModel.contentUnitTag.config.playerConfig.player
    );

    config = {
      ...config,
      export: true,
      unitVersion: {
        'z-player': `https://c.${servingDomain}/player/z-player.2.1${
          config.unitVersion ? `.${config.unitVersion}` : ''
        }.js`,
        composer: `https://c.${servingDomain}/contentgen/contentgen${
          config.composerVersion ? `_${config.composerVersion}` : ''
        }.js`,
      },
    };

    for (const attr of Object.keys(config)) {
      global_defs[
        `$$_${attr
          .replace(/[\w]([A-Z])/g, function (m) {
            return m[0] + '_' + m[1];
          })
          .toUpperCase()}`
      ] = config[attr];
    }

    const { code, error } = minify(config.template, {
      mangle: false,
      output: {
        beautify: true,
      },
      compress: {
        booleans: false,
        arguments: false,
        collapse_vars: false,
        comparisons: false,
        inline: false,
        join_vars: false,
        hoist_props: false,
        negate_iife: false,
        global_defs,
      },
    });
    if (error) {
      console.error(error);
      return null;
    }
    return code;
  }

  getCustomPlayerSizeId(width: number, height: number, operator: string) {
    let num: number = width * height;
    switch (operator) {
      case '=':
        return `a:${num}-${num}`;
      case '>':
        num += 1;
        return `a:${num}-all`;
      case '<':
        num -= 1;
        return `a:0-${num}`;
      case '≥':
        return `a:${num}-all`;
      case '≤':
        return `a:0-${num}`;
      default:
        return '';
    }
  }

  isFixedCPM(costType: number) {
    costType = Number(costType);
    return costType === 2 || costType === 3 || costType === 5;
  }

  isRevshareCPM(costType: number) {
    costType = Number(costType);
    return costType === 1 || costType === 4;
  }

  getSupplyTypes(showAll: boolean = false) {
    const supplyTypes: Array<any> = [];
    let passFeatureFlag: boolean;
    let passPublisher: boolean;
    for (let i = 0; i < this.supplyTypes.length; i++) {
      passFeatureFlag = this.supplyTypes[i].featureFlag
        ? this.userService.getFeatureState(this.supplyTypes[i].featureFlag)
        : true;
      passPublisher =
        this.userService.isPublisher() || this.userService.isPublisherNetwork()
          ? this.supplyTypes[i].hideFromPublishersNetwork !== true
          : true;
      if (this.supplyTypes[i].active && ((passFeatureFlag && passPublisher) || showAll)) {
        supplyTypes.push(this.supplyTypes[i]);
      }
    }
    return supplyTypes;
  }

  buildExtraParamsDefs() {
    return {
      extra_params_enabled: false,
      extra_params: this.extraParamsDefaultValue.json,
      extra_params_url: this.extraParamsDefaultValue.url,
    };
  }
}
